import type {Customer} from "@/components/customers/scripts/types";
import {
    createNewAddress,
    createEmptyBankAccount,
    createEmptyLogo,
    createNewPerson,
    createEmptyPaymentDetails,
} from "@/scripts/Common/helpers";

import {
  CustomerState,
} from "@/Enums";

import {
  createEmptyBankTransferDetails,
} from "@/components/children/bankTransferDetails/scripts";

const createEmptyCustomer = () => {
    const customer: Customer = {
        id: 0,
        companyName: '',
        contactEmployeeId: 0,
        contactEmployee: createNewPerson(),
        taxNumber: undefined,
        vatIdentificationNumber: undefined,
        contactAddressId: 0,
        contactAddress: createNewAddress(),
        businessAddressId: 0,
        businessAddress: createNewAddress(),
        pointOfSalesCount: undefined,
        status: CustomerState.Interested,
        interestedNumber: undefined,
        provision: undefined,
        businessBankAccountId: 0,
        businessBankAccount: createEmptyBankAccount(),
        creditorId: undefined,
        debitorId: undefined,
        isWebsitePartner: false,
        websiteUrl: '',
        websiteLogo: createEmptyLogo(),
        useVoucher: false,
        voucherAmount: 0,
        useEcTerminal: false,
        hardware: '',
        isInternetAvailable: false,
        deploymentDate: undefined,
        isSparkassenKunde: false,
        category: '',
        isEmployer: false,
        serviceIds: [],
        bankAccountCreditorId: undefined,
        contractStart: undefined,
        contractEnd: undefined,
        serviceEnd: undefined,
        bankTransferDetailsId: 0,
        bankTransferDetails: createEmptyBankTransferDetails(),
        paymentDetailsId: 0,
        paymentDetails: createEmptyPaymentDetails()
    }

    return customer;
}

export {
    createEmptyCustomer,
}
